import React, { useEffect, useState } from 'react'
import PageLayout from '../../components/PageLayout';
import BackButton from '../../assets/images/lystfacelogos/BackButton.svg';
import { getUsageDetails } from '../../store/menu/usage/actions';
import { useDispatch, useSelector } from 'react-redux';
import CustomCard from '../../components/Common/CustomCard';
import UsageTable from './UsageTable';
import moment from "moment";
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { getListOfApps } from '../../store/menu/home/actions';
import { object } from 'yup';
import Cookies from 'js-cookie';



const pageName = "Usage";
const breadcrumbItems = [
    { text: "Home", link: "/" },
    { text: pageName, link: "/usage" },
]
const tableHeader = [
    { title: "Method", value: "method" },
    { title: "From", value: "from_date" },
    { title: "To", value: "to_date" },
    { title: "Traffic", value: "hits" },

]
const Usage = () => {
    const dispatch = useDispatch()
    const UsageProps = useSelector(state => state.Usage)
    const { responseMessage, responseStatus, loading, usageDetails } = UsageProps
    const today = dayjs();
    const [date, setDate] = useState(today);
    const [exporting, setExporting] = useState(false);
    const HomeState = useSelector(state => state.Home.appsListDetails)
    const { appsList, responseCode: appListFetched } = HomeState
    const navigate = useNavigate();
    const [usageInfo, setUsageInfo] = useState({
        from_date: today.subtract(24, 'hour'),
        to_date: today.subtract(1, 'minute'),
        duration: "hour",
        format: '24h',

    })
    const [dataforExport, setDataforExport] = useState({})
    const [applicationList, setApplicationList] = useState([])

    useEffect(() => {
        setApplicationList(appsList.length === 0 ? [{ 'app_name': 'All apps', 'app_id': 'allApps' }] : [{ 'app_name': 'All apps', 'app_id': 'allApps' }, ...appsList])
    }, [appsList])



    useEffect(() => {
        if (appsList.length === 0 && !appListFetched) {
            dispatch(getListOfApps({}))
        }

    }, [])

    useEffect(() => {
        if (!usageInfo?.app && appsList?.length > 0) {
            const lastUsedAppId = Cookies.get('USG_APP_ID')
            const lastUsedApp = appsList.find(obj => obj?.app_id === lastUsedAppId)
            setUsageInfo({ ...usageInfo, app: lastUsedApp ? lastUsedApp : { 'app_name': 'All apps', 'app_id': 'allApps' } })
        }
    }, [appsList])

    useEffect(() => {
        if (usageInfo && usageInfo?.app) {
            let startDate = usageInfo?.format === "24h" ? usageInfo?.from_date.toISOString() : usageInfo?.from_date.format('YYYY-MM-DDTHH:mm:ss')
            let endDate = usageInfo?.format === "24h" ? usageInfo?.to_date.toISOString() : usageInfo?.to_date.format('YYYY-MM-DDTHH:mm:ss')
            dispatch(getUsageDetails({ startDate: startDate, endDate: endDate, granularity: usageInfo?.duration, appId: usageInfo?.app?.app_id === "allApps" ? null : usageInfo?.app?.app_id }))
        }
    }, [usageInfo?.from_date, usageInfo?.to_date, usageInfo?.duration, usageInfo?.app])



    const handleDurationChange = (duration) => {
        let from_date, to_date, perduration;



        switch (duration) {
            case '24h':
                from_date = today.subtract(24, 'hour');
                to_date = today.subtract(1, 'minute');
                perduration = "hour"
                break;
            case '7d':
                from_date = today.subtract(6, 'day');
                to_date = today;
                perduration = "day"

                break;
            case '30d':
                from_date = today.subtract(29, 'day');
                to_date = today;
                perduration = "day"

                break;
            case '12m':
                from_date = today.subtract(11, 'month');
                to_date = today;
                perduration = "month"

                break;
        }
        setUsageInfo({
            ...usageInfo,
            from_date: from_date || usageInfo?.from_date,
            to_date: to_date || usageInfo?.to_date,
            format: duration,
            duration: perduration || usageInfo?.duration

        })


    };

    const onInfoChange = (value, key) => {
        if (key === "to_date" || key === "from_date") {
            let startDate = {}
            let endDate = {}
            if (key === "from_date") {
                startDate = value.startOf('day')
                endDate = usageInfo?.to_date?.endOf('day')
            }
            else {
                startDate = usageInfo?.from_date?.startOf('day')
                endDate = value.endOf('day')
            }
            setUsageInfo({ ...usageInfo, from_date: startDate, to_date: endDate, format: "" })

        }
        else if (key === "duration") {
            let startDate = usageInfo?.from_date.startOf('day')
            let endDate = usageInfo?.to_date?.endOf('day')
            setUsageInfo({ ...usageInfo, from_date: startDate, to_date: endDate, [key]: value, format: "" })

        }
        else {
            setUsageInfo({ ...usageInfo, [key]: value })
        }

    }


    const formatCSVValue = (value) => {
        if (typeof value === "string") {
            return `"${value.replace(/"/g, '""')}"`;
        } else if (value === null || value === undefined) {
            return "";
        } else {
            return value;
        }
    };

    const convertToCSV = (data) => {
        const header = dataforExport?.header.map((col) => col.title);
        const headerValues = dataforExport?.header.map((col) => col.value);
        const rows = data.map((row) =>
            headerValues.map((fieldName) => formatCSVValue(row[fieldName])).join(",")
        );
        return [header.join(","), ...rows].join("\n");
    };

    const downloadCSV = (csv, filename) => {
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleExport = () => {
        setExporting(true);
        setTimeout(() => {
            const csv = convertToCSV(dataforExport?.data);
            downloadCSV(csv, `${usageInfo?.app?.app_id === "allApps" ? "Usage.csv" : `Usage - ${usageInfo?.app?.app_name}.csv`}`);
            setExporting(false);
        }, 1000);
    }

    const buttonDetails = [
        { 'buttonText': 'Download CSV', buttonType: 'primary', callBackFunction: () => handleExport() }
    ]

    const onClickBack = () => {
        navigate("/dashboard")
    }

    const handleChangeApp = (appName) => {
        let app = appsList.find(obj => obj?.app_name === appName)
        Cookies.set("USG_APP_ID", app?.app_id)
        setUsageInfo({ ...usageInfo, app: app ? app : { 'app_name': 'All apps', 'app_id': 'allApps' } })

    }
    return (
        <PageLayout pageName={pageName} breadcrumbItems={breadcrumbItems}>
            <div className='singleLineCard'>
                <div className='flexData'>
                    <img src={BackButton} alt="lystface maroof" className='back-icon' onClick={onClickBack} />
                    <div className='heading'>Usage</div>
                </div>
                {(applicationList.length !== 0) &&
                    // <div className='app_name'>
                    <select
                        name="app_name"
                        id=""
                        className={`input-value-filed`}
                        onChange={(e) => {
                            e.target.value = e.target.value;
                            handleChangeApp(e.target.value)
                        }}
                        value={usageInfo?.app ? usageInfo?.app?.app_name : applicationList[0]?.app_name}
                    >
                        {applicationList?.map(app => (
                            <option
                                value={app.app_name}
                                key={app.app_id}
                            >
                                {`${app.app_name}`}
                            </option>
                        ))}
                    </select>

                    // </div>
                }

            </div>
            <div className='usage-details-container'>
                <CustomCard
                    customBtnLoading={!(usageDetails?.data && applicationList.length !== 0)}
                    applicationLoading={exporting}
                    titleText={"All requests"}
                    buttonsList={buttonDetails}>
                    <UsageTable tableHeader={tableHeader} usageDetails={usageDetails} loading={loading} usageInfo={usageInfo} onInfoChange={onInfoChange} handleDurationChange={handleDurationChange} responseMessage={responseMessage} setDataforExport={setDataforExport} appsList={applicationList} />
                </CustomCard>
            </div>



        </PageLayout>
    )
}
export default Usage
